import React from 'react';

export interface ActiveFilterChipProps {
  label: string;
  value: string;
  onRemove: () => void;
}

/**
 * ActiveFilterChip — removable chip displaying "label: value ×".
 * Uses emerald accent color to indicate active state.
 */
export default function ActiveFilterChip({
  label,
  value,
  onRemove,
}: ActiveFilterChipProps) {
  return (
    <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent/15 border border-accent text-accent-fg text-sm">
      <span>
        <span className="font-semibold">{label}:</span>{' '}
        <span>{value}</span>
      </span>
      <button
        onClick={onRemove}
        aria-label={`Remove ${label}: ${value} filter`}
        className="ml-1 font-bold text-accent-fg hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-accent rounded px-0.5"
      >
        ×
      </button>
    </div>
  );
}
